import { Injectable } from '@angular/core';

export class IntercomEvents {
  public static readonly LOGIN_WEB = 'LOGIN_WEB';
  public static readonly TEMPLATE_CREATED = 'TEMPLATE_CREATED';
  public static readonly JOB_POSTED = 'JOB_POSTED';
  public static readonly LISTING_BLOCK_ADDED = 'JOB_LISTING_BLOCK_ADDED';
  public static readonly LISTING_VIDEO_BLOCK_ADDED =
    'JOB_LISTING_VIDEO_BLOCK_ADDED';
  public static readonly MOVED_CANDIDATE_TO_QUALIFIED =
    'MOVED_CANDIDATE_TO_QUALIFIED';
  public static readonly VIEWED_VIDEO_ANSWER = 'VIEWED_VIDEO_ANSWER';
  public static readonly SENT_CHAT_MESSAGE = 'SENT_CHAT_MESSAGE';
  public static readonly MOVED_CANDIDATE_TO_HIRED = 'MOVED_CANDIDATE_TO_HIRED';
}

@Injectable()
export class IntercomService {
  constructor() {}

  public bootIntercom(params: any) {
    (<any>window).Intercom('boot', params);
  }

  public updateIntercomUser(params: any) {
    (<any>window).Intercom('update', params);
  }

  public updateIntercomCompany(params: any) {
    (<any>window).Intercom('update', {
      company: params,
    });
  }

  public trackEvent(eventName: string, metadata: any = null) {
    if (metadata) {
      (<any>window).Intercom('trackEvent', eventName, metadata);
      return;
    }

    (<any>window).Intercom('trackEvent', eventName);
  }

  // Intercom requires an update on url change for SPAs
  public onNavigation() {
    (<any>window).Intercom('update', {});
  }
}
